/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-14 11:59:17
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 16:33:15
 */
import "./assets/css/common.css";
import "./assets/css/animate.less";
import Vue from "vue";
import store from "./store/index.js";
import router from "./router/index.js";
import errorHandler from "./error";
import { bus, myUtils, filters, constants, myStorage } from "./utils";
import apis from "./apis";
import { toast, components, LazyLoad } from "./vant";
import Loading from "./utils/loading.js";
import axios from "@/apis/axios";
import initsocket from "./socket";
import {fetchConfig,config} from "./config";
// 开发环境下面使用vConsole进行调试
// if (!isdev) {
//   const VConsole = require("vconsole");
//   new VConsole();
// }

//引用组件
Vue.use(Loading);
components.forEach(component => Vue.use(component));
Vue.use(LazyLoad, {
  preLoad: 1.3,
  loading: require("./assets/img/img_placeholder.png"),
  error: require("./assets/img/img_placeholder.png"),
  attempt: 1
});
// 挂载属性
Vue.prototype.bus = bus;
Vue.prototype.apis = apis;
Vue.prototype.toast = toast;
Vue.prototype.myUtils = myUtils;
Vue.prototype.constants = constants;
Vue.prototype.$addStorageEvent = myStorage.addStorageEvent;
Vue.prototype.$throw = error => errorHandler(error, this);

//全局注册 filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.config.errorHandler = errorHandler;

function init() {
  return new Promise(resolve => {
    fetchConfig().then(({ axios:axiosconfig, socketURL, sys }) => {
      axios.init(axiosconfig);
      Vue.use(config,sys)
      return initsocket(socketURL)
    }).then(({ io, subscribe, unsubscribe }) => {
      io && Vue.use(io);
      resolve({ Vue, store, router, subscribe, unsubscribe });
    });
  });
}
export default init;
